import React, { Fragment, useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Redirect, useLocation, useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import "../css/login.css"

import { forgotPasswordAction } from "../actions/userActions"
import { ROUTES } from "../utils"

const PageForgotPassword = () => {
	const history = useHistory()
	const location = useLocation()
	const dispatch = useDispatch()
	const [t] = useTranslation("global")
	const users = useSelector((state) => state.users)
	const [username, setUsername] = useState("")
	const anzyz_legal_logo = window._env_.REACT_APP_DASHBOARD_LOGO || anzyz_logo

	const submitLogin = () => {
		dispatch(forgotPasswordAction(username))
	}

	useEffect(() => {
		localStorage.removeItem("user")
		const backgroundImg = window._env_.REACT_APP_BACKGROUND
		document.body.style.backgroundImage = "url('" + backgroundImg + "')"
		document.body.classList.add("newLoginPage")
		return () => {
			document.body.style.backgroundImage = "none"
			document.body.classList.remove("newLoginPage")
		}
	}, [])

	useEffect(() => {
		if (users?.redirectToHome) {
			history.push(ROUTES.DEFAULT, { from: "forgotPassword" })
		}
	}, [users])

	return (
		<Fragment>
			<div className="wrapper bg-white">
				<div className="h2 text-center">
					<img src={anzyz_legal_logo} width="100%" height="auto" alt=" " className="logo_producto" />
				</div>

				<Fragment>
					<div className="h4 text-muted text-center pt-2">{t("forgotPassword.forgotPasswordLabel")}</div>
					<div className="pt-3">
						<div className="form-group py-2">
							<div className="input-field">
								{" "}
								<span className="far fa-user p-2"></span>{" "}
								<input
									type="text"
									placeholder="Email"
									className="qa-username"
									value={username}
									onChange={(e) => setUsername(e.target.value)}
									data-testid="username"
									data-cy="username_input"
								/>
							</div>
						</div>
					</div>
					<div className="d-flex align-items-start  my-3">
						<button
							onClick={() => {
								submitLogin()
							}}
							className="btn btn-block text-center qa-login"
							data-testid="login_submit"
							data-cy="login_submit"
							disabled={username.length <= 0}
						>
							{t("forgotPassword.reset")}
						</button>
						<button
							className="btn btn-block text-center qa-login"
							style={{ backgroundColor: "#E0E0E0", marginLeft: "10px", padding: "10px 25px", color: "#000000DE" }}
							onClick={(e) => {
								history.push(ROUTES.DEFAULT)
							}}
						>
							{t("forgotPassword.cancel")}
						</button>
					</div>
				</Fragment>
			</div>
		</Fragment>
	)
}

export default PageForgotPassword
